import React from 'react';

import {observer} from "mobx-react";
import {MatchWidgetAsync} from "../../../match-widget/components/match-widget.async";

export const GameCenterWidgetContentMatchTab = observer(({controller, matchupId, gameId, location, showOdds, onSeeAllClick}) => {
  const {state} = controller;
  const {shouldRenderMatch} = state;

  const matchProps = {
    matchupId,
    gameId,
    location,
    showOdds,
    onSeeAllClick,
  }

  return (shouldRenderMatch ? <>
    <MatchWidgetAsync {...matchProps}/>
  </> : null)
});
